import { RouterProvider, createBrowserRouter } from "react-router-dom";
import Root from "./routes/Root";

// ==========================
// VISTAS PÚBLICAS
// ==========================
import Principal from "./view/Principal";
import SignIn from "./view/logsPags/Sign";
import Subscribirse from "./view/subsPags/SubsPags";
import Contacto from "./view/contacto/Contacto";
import SobreNosotros from "./view/sobreNosotros/sobreNosotros";
import Profesionales from "./view/profesionales/Profesionales";
import Profesiones from "./view/profesiones/Profesiones";
import Profesional from "./view/profesionales/profesional/Profesional";
import AvisoLegal from "./view/avisoLegal/AvisoLegal";
import PoliticaPriv from "./view/politicaPriv/PoliticaPrivacidad";
import CookiePolicy from "./view/politicaCookies/CookiePolicy";
import ContratosFacturas from "./view/contratosFacturas/ContratosFacturas";
import ErrorPage from "./components/error/ErrorPage";
import CodigoRecuperacion from "./components/forms/loginForm/CodigoRecuperacion";
import VerificaCodigo from "./components/forms/loginForm/VerificaCodigo";
import IntroduceNuevaContrasena from "./components/forms/loginForm/IntroduceNuevaContrasena";

// ==========================
// RUTAS PRIVADAS Y COMPONENTES
// ==========================
import EligeProfesionEditar from "./view/profesionales/editPofesional/EligeProfesionEditar";
import ListadoDeProfesiones from "./components/forms/editarPerfilForm/ListadoDeProfesiones";
import EditaDatosProfesional from "./view/profesionales/editPofesional/EditaDatoProfesional";
import EditaUsuario from "./view/usuario/DatosUsuario";
import Pago from "./components/forms/subcribirseForm/pagos/Pago";
import SuccessPage from "./components/forms/subcribirseForm/pagos/SuccessPage";
import VerificacionEnviada from "./components/forms/registerForm/VerificacionEnviada";
import ContratoServicios from "./view/contratosFacturas/ContratoServicios";
import Renovar from "./view/renovar/RenovarView";
import PaginaCookieRechazada from "./components/docs/PaginaCookieRechazada";
import CookieConsentModal from "./components/docs/CookieConsentModal";
import PopuBajaDefinitiva from "./components/popup/PopupBajaDefinitiva";
import PrivateRoute from "./PrivateRoute";
import Offline from "./pages/Offline";
import InsertarSecciones from "./components/admin/secciones/InsertarSecciones";
import EditarSecciones from "./components/admin/secciones/EditarSecciones";
import Backoffice from "./components/admin/Backoffice";
import BorrarSecciones from "./components/admin/secciones/BorrarSecciones";
import InsertarProfesiones from "./components/admin/profesiones/InsertarProfesiones";
import EditarProfesiones from "./components/admin/profesiones/EditarProfesiones";
import BorrarProfesiones from "./components/admin/profesiones/BorrarProfesiones";
import BuscarProfesionales from "./components/admin/profesionales/BuscarProfesionales";
import EditarProfesionales from "./components/admin/profesionales/EditarProfesionales";
import BajaProfesionales from "./components/admin/profesionales/BajaProfesionales";
import EditarUsuarios from "./components/admin/usuario/EditarUsuario";
import BuscarUsuarioDetalle from "./components/admin/usuario/BuscarUsuario";
import GestionUsuarioAdmin from "./components/admin/usuario/GestionUsuarioAdmin";
import CrearAfiliado from "./components/admin/afiliados/CrearAfiliados";
import Afiliados from "./components/admin/afiliados/Afiliados";
import ResumenAfiliados from "./components/admin/afiliados/ResumenAfiliados";
import EditarAfiliados from "./components/admin/afiliados/EditarAfiliado";
import BajaAfiliados from "./components/admin/afiliados/BajaAfiliados";
import SuperAdminUsuarios from "./components/admin/SuperAdminUsuarios";
import CrearAdmin from "./components/admin/CrearAdmin";
import FacturasResumen from "./components/admin/facturas/FacturasResumen";
import { HeaderProvider } from "./context/HeaderContext";
import { SearchProvider } from "./components/bodyBlocks/cardsBlock/buscarFiltrar/SearchContext";
import ContratosResumen from "./components/admin/contratos/ContratosResumen";
import PanelAfiliados from "./components/admin/afiliados/panelAfiliados/PanelAfiliados";
import CookieBlockedLanding from "./pages/CookieBlockedLanding";
import OfflineBackendPage from "./pages/OffineBackendPage";
/* import LandingModule from "./landingPage/LandingModule"; */
import LandingLayout from "./landingPage/layout/LandingLayout";
import LandingPage from "./landingPage/pages/LandingPage";
import OfertasLanding from "./landingPage/pages/OfertasLanding";
import EmpleoLanding from "./landingPage/pages/EmpleoLanding";
import ContactoLanding from "./landingPage/pages/ContactoLanding";
import QuienesSomosLanding from "./landingPage/pages/QuieneSomoLanding";
import EditarOfertasLanding from "./landingPage/editarLanding/EditarOfertasLanding";
import EditarEmpleoLanding from "./landingPage/editarLanding/EditarEmpleoLanding";
import EditarContactoLanding from "./landingPage/editarLanding/EditarContactoLanding";
import EditarQuienesSomosLanding from "./landingPage/editarLanding/EditarQuienesSomosLanding";
import EditarLandingLayout from "./landingPage/editarLanding/EditarLandingLayout";
import EditarHeroSection from "./landingPage/editarSection/EditarHeroSection";
import EditarServicesSection from "./landingPage/editarSection/EditarServicesSection";
import EditarFooterSection from "./landingPage/editarSection/EditarFooterSection";
import EditarContactSection from "./landingPage/editarSection/EditarContactSection";
import { ProfesionalProvider } from "./landingPage/context/ProfesionalContext";
import EditarFondoWeb from "./landingPage/editarLanding/EditarLandingPrincipal";
import SelectorLanding from "./landingPage/editarLanding/hook/SelectorLanding";
import EliminarCuenta from "./components/docs/EliminarCuenta";
import PromocionesGenerales from "./components/admin/afiliados/panelAfiliados/PromocionesGenerales";
import GestionDonaciones from "./components/admin/donaciones/GestionDonaciones";
import GestionBeneficiarios from "./components/admin/donaciones/GestionBeneficiarios";
/* import LandingPage from "./landingPage/pages/LandingPage"; */

/* import { useEffect } from "react"; */

const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    children: [
      // --- RUTAS PÚBLICAS ---
      { index: true, element: <Principal /> },
      { path: "sign", element: <SignIn /> },
      { path: "suscribirse", element: <Subscribirse /> },
      { path: "contacto", element: <Contacto /> },
      { path: "sobreNosotros", element: <SobreNosotros /> },
      { path: "profesiones/:seccion?", element: <Profesiones /> },
      { path: "profesionales/:servicio", element: <Profesionales /> },
      {
        path: "profesional/:servicio_name/:profesional_name",
        element: <Profesional />,
      },
      { path: "politicaPrivacidad", element: <PoliticaPriv /> },
      { path: "politicaCookies", element: <CookiePolicy /> },
      { path: "avisoLegal", element: <AvisoLegal /> },
      { path: "contratoServicios", element: <ContratoServicios /> },
      { path: "codigoRecuperacion", element: <CodigoRecuperacion /> },
      { path: "verificarCodigo", element: <VerificaCodigo /> },
      {
        path: "introduceNuevaContrasena",
        element: <IntroduceNuevaContrasena />,
      },
      { path: "success", element: <SuccessPage /> },
      {
        path: "renovar/:profesional_id/:perfil_profesional_id",
        element: <Renovar />,
      },
      { path: "VerificacionEnviada", element: <VerificacionEnviada /> },
      { path: "cookieConsentModal", element: <CookieConsentModal /> },
      { path: "paginaCookieRechazada", element: <PaginaCookieRechazada /> },
      { path: "popuBajaDefinitiva", element: <PopuBajaDefinitiva /> },
      { path: "cookies-bloqueadas", element: <CookieBlockedLanding /> },
      { path: "eliminacion-cuenta", element: <EliminarCuenta /> },
      {
        path: "landing/:id",
        element: (
          <ProfesionalProvider>
            <LandingLayout />
          </ProfesionalProvider>
        ),
        children: [
          {
            index: true,
            element: <LandingPage />,
          },
          {
            path: "ofertas",
            element: <OfertasLanding />,
          },
          {
            path: "empleo",
            element: <EmpleoLanding />,
          },
          {
            path: "contacto",
            element: <ContactoLanding />,
          },
          {
            path: "quienes-somos",
            element: <QuienesSomosLanding />,
          },
        ],
      },

      {
        path: "editar-landing/:profesionalId/:profesionId/:perfilId",
        element: (
          <PrivateRoute roles={["profesional", "admin", "superadmin"]}>
            <EditarLandingLayout />
          </PrivateRoute>
        ),
        children: [
          {
            index: true,
            element: <SelectorLanding />, // <-- aquí va tu modal convertido en página
          },
          {
            path: "fondoWeb",
            element: <EditarFondoWeb />,
          },
          {
            path: "ofertas",
            element: <EditarOfertasLanding />,
          },
          {
            path: "empleo",
            element: <EditarEmpleoLanding />,
          },
          {
            path: "contacto",
            element: <EditarContactoLanding />,
          },
          {
            path: "quienes-somos",
            element: <EditarQuienesSomosLanding />,
          },
          {
            path: "editaHero",
            element: <EditarHeroSection />,
          },
          {
            path: "editaServices",
            element: <EditarServicesSection />,
          },
          {
            path: "editaContacto",
            element: <EditarContactSection />,
          },
          {
            path: "editaFooter",
            element: <EditarFooterSection />,
          },
        ],
      },

      // --- RUTA SIN CONEXIÓN ---
      { path: "offline", element: <Offline /> },
      { path: "/offline-backend", element: <OfflineBackendPage /> },
      /*  { path: "/landingPrincipal/:id", element: <LandingPage /> }, */

      // --- RUTAS PRIVADAS ---
      {
        path: "contratosFacturas",
        element: (
          <PrivateRoute>
            <ContratosFacturas />
          </PrivateRoute>
        ),
      },
      {
        path: "edit-Profesional",
        element: (
          <PrivateRoute roles={["profesional"]}>
            <EligeProfesionEditar />
          </PrivateRoute>
        ),
      },
      {
        path: "profesionales/:profesionalId/profesiones",
        element: (
          <PrivateRoute roles={["profesional"]}>
            <ListadoDeProfesiones />
          </PrivateRoute>
        ),
      },
      {
        path: "editProfesional/:profesionalId/:profesionId/:perfilId",
        element: (
          <PrivateRoute roles={["profesional"]}>
            <EditaDatosProfesional />
          </PrivateRoute>
        ),
      },
      {
        path: "editaUsuario",
        element: (
          <PrivateRoute
            roles={[
              "usuario",
              "profesional",
              "afiliado",
              "admin",
              "superadmin",
            ]}
          >
            <EditaUsuario />
          </PrivateRoute>
        ),
      },
      {
        path: "pago",
        element: (
          <PrivateRoute>
            <Pago />
          </PrivateRoute>
        ),
      },
      {
        path: "panelAfiliado",
        element: (
          <PrivateRoute
            roles={["afiliado", "profesional", "admin", "superadmin"]}
          >
            <PanelAfiliados />
          </PrivateRoute>
        ),
      },
      {
        path: "backoffice",
        element: (
          <PrivateRoute roles={["admin", "superadmin"]}>
            <Backoffice />
          </PrivateRoute>
        ),
      },
      {
        path: "insertarSecciones",
        element: (
          <PrivateRoute roles={["admin", "superadmin"]}>
            <InsertarSecciones />
          </PrivateRoute>
        ),
      },
      {
        path: "editarSecciones",
        element: (
          <PrivateRoute roles={["admin", "superadmin"]}>
            <EditarSecciones />
          </PrivateRoute>
        ),
      },
      {
        path: "borrarSecciones",
        element: (
          <PrivateRoute roles={["admin", "superadmin"]}>
            <BorrarSecciones />
          </PrivateRoute>
        ),
      },
      {
        path: "insertarProfesiones",
        element: (
          <PrivateRoute roles={["admin", "superadmin"]}>
            <InsertarProfesiones />
          </PrivateRoute>
        ),
      },
      {
        path: "editarProfesion",
        element: (
          <PrivateRoute roles={["admin", "superadmin"]}>
            <EditarProfesiones />
          </PrivateRoute>
        ),
      },
      {
        path: "borrarProfesiones",
        element: (
          <PrivateRoute roles={["admin", "superadmin"]}>
            <BorrarProfesiones />
          </PrivateRoute>
        ),
      },
      {
        path: "buscarProfesionales",
        element: (
          <PrivateRoute roles={["admin", "superadmin"]}>
            <BuscarProfesionales />
          </PrivateRoute>
        ),
      },
      {
        path: "editar-Profesional",
        element: (
          <PrivateRoute roles={["admin", "superadmin"]}>
            <EditarProfesionales />
          </PrivateRoute>
        ),
      },
      {
        path: "bajaProfesional",
        element: (
          <PrivateRoute roles={["admin", "superadmin"]}>
            <BajaProfesionales />
          </PrivateRoute>
        ),
      },
      {
        path: "editarUsuarioAdmin",
        element: (
          <PrivateRoute roles={["admin", "superadmin"]}>
            <EditarUsuarios />
          </PrivateRoute>
        ),
      },
      {
        path: "buscarUsuarioAdmin",
        element: (
          <PrivateRoute roles={["admin", "superadmin"]}>
            <BuscarUsuarioDetalle />
          </PrivateRoute>
        ),
      },
      {
        path: "gestionUsuarioAdmin",
        element: (
          <PrivateRoute roles={["admin", "superadmin"]}>
            <GestionUsuarioAdmin />
          </PrivateRoute>
        ),
      },
      {
        path: "afiliados",
        element: (
          <PrivateRoute roles={["admin", "superadmin"]}>
            <Afiliados />
          </PrivateRoute>
        ),
      },
      {
        path: "promocionesGenerales",
        element: (
          <PrivateRoute roles={["admin", "superadmin"]}>
            <PromocionesGenerales />
          </PrivateRoute>
        ),
      },

      {
        path: "crearAfiliado",
        element: (
          <PrivateRoute roles={["admin", "superadmin"]}>
            <CrearAfiliado />
          </PrivateRoute>
        ),
      },
      {
        path: "resumenAfiliado",
        element: (
          <PrivateRoute roles={["admin", "superadmin"]}>
            <ResumenAfiliados />
          </PrivateRoute>
        ),
      },
      {
        path: "editarAfiliado",
        element: (
          <PrivateRoute roles={["admin", "superadmin"]}>
            <EditarAfiliados />
          </PrivateRoute>
        ),
      },
      {
        path: "bajaAfiliado",
        element: (
          <PrivateRoute roles={["admin", "superadmin"]}>
            <BajaAfiliados />
          </PrivateRoute>
        ),
      },
      {
        path: "superAdmin",
        element: (
          <PrivateRoute roles={["admin", "superadmin"]}>
            <SuperAdminUsuarios />
          </PrivateRoute>
        ),
      },
      {
        path: "facturasResumen",
        element: (
          <PrivateRoute roles={["admin", "superadmin"]}>
            <FacturasResumen />
          </PrivateRoute>
        ),
      },
      {
        path: "contratosResumen",
        element: (
          <PrivateRoute roles={["admin", "superadmin"]}>
            <ContratosResumen />
          </PrivateRoute>
        ),
      },
      {
        path: "crearAdmin",
        element: (
          <PrivateRoute roles={["superadmin"]}>
            <CrearAdmin />
          </PrivateRoute>
        ),
      },
      {
        path: "gestionDonaciones",
        element: (
          <PrivateRoute roles={["superadmin"]}>
            <GestionDonaciones />
          </PrivateRoute>
        ),
      },
      {
        path: "gestionBeneficiarios",
        element: (
          <PrivateRoute roles={["superadmin"]}>
            <GestionBeneficiarios onBeneficiariosChanged={async () => {}} />
          </PrivateRoute>
        ),
      },

      // --- RUTA DE ERROR ---
      { path: "errorPage", element: <ErrorPage /> },
      { path: "*", element: <ErrorPage /> },
    ],
  },
]);

export default function App() {
  return (
    <HeaderProvider>
      <SearchProvider>
        <RouterProvider router={router} />
      </SearchProvider>
    </HeaderProvider>
  );
}

/*  useEffect(() => {
  const disableContextMenu = (e: MouseEvent) => {
    e.preventDefault();
  };

  const disableKeys = (e: KeyboardEvent) => {
    // F12
    if (e.key === "F12") {
      e.preventDefault();
    }

    // Ctrl + Shift + I (Windows / Linux)
    if (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === "i") {
      e.preventDefault();
    }

    // Ctrl + U
    if (e.ctrlKey && e.key.toLowerCase() === "u") {
      e.preventDefault();
    }

    // Cmd + Option + I (Mac)
    if (e.metaKey && e.altKey && e.key.toLowerCase() === "i") {
      e.preventDefault();
    }
  };

  document.addEventListener("contextmenu", disableContextMenu);
  document.addEventListener("keydown", disableKeys);

  return () => {
    document.removeEventListener("contextmenu", disableContextMenu);
    document.removeEventListener("keydown", disableKeys);
  };
}, []);  */
